import styled from 'styled-components/macro';

import { ReactComponent as Alert } from '@src/assets/icons/alert.svg';

export interface BlockErrorProps {
  message: string;
}

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-5);
`;

const StyledText = styled.p`
  font-weight: var(--font-weight-medium);
`;

const StyledIcon = styled(Alert)`
  color: var(--color-secondary-red-1);
`;

/** An error that consists of an alert icon and a message below it. */
export function BlockError({ message }: BlockErrorProps) {
  return (
    <StyledContainer role="status">
      <StyledIcon aria-hidden />
      <StyledText>{message}</StyledText>
    </StyledContainer>
  );
}
